<script lang="ts">
	import { onDestroy, onMount } from 'svelte';
	import { DashLayout } from '@Shelly/shelly-design-system';
	import DashListHolderNew from 'src/components/Lists/Dashboards/DashListHolderNew.svelte';
	import ListSkeletonGrid from 'src/components/Lists/ListSkeletonGrid.svelte';
	import { devices } from 'src/stores/lists/devices';
	import { forceListSkeleton } from 'src/stores/features/dev/force-list-skeleton';
	import {
		ALL_DEVICE_WIDGETS_DASHBOARD_ID,
		buildAllDeviceWidgetsDashboard,
	} from './all-device-widgets';

	/** Short defer so HomeBackground can start its cross-fade before 2×N cards mount. */
	const WIDGET_MOUNT_DEFER_MS = 50;
	const SKELETON_CARD_COUNT = 8;

	const dashboardOverride = $derived(buildAllDeviceWidgetsDashboard($devices));

	let widgetsReady = $state(false);
	let deferTimer: ReturnType<typeof setTimeout> | null = null;
	let deferRaf1 = 0;
	let deferRaf2 = 0;

	onMount(() => {
		deferRaf1 = requestAnimationFrame(() => {
			deferRaf1 = 0;
			deferRaf2 = requestAnimationFrame(() => {
				deferRaf2 = 0;
				deferTimer = setTimeout(() => {
					deferTimer = null;
					widgetsReady = true;
				}, WIDGET_MOUNT_DEFER_MS);
			});
		});
	});

	onDestroy(() => {
		if (deferRaf1) cancelAnimationFrame(deferRaf1);
		if (deferRaf2) cancelAnimationFrame(deferRaf2);
		if (deferTimer) clearTimeout(deferTimer);
	});
</script>

{#if widgetsReady && !$forceListSkeleton}
	<DashListHolderNew
		id={ALL_DEVICE_WIDGETS_DASHBOARD_ID}
		{dashboardOverride}
		allowAddWidgets={false}
		allowManageWidgets={false}
		allowReorderWidgets={false}
	/>
{:else}
	<div
		class="all-device-widgets-skeleton"
		aria-busy="true"
		aria-live="polite"
		aria-label="Loading device widgets"
	>
		<DashLayout>
			<svelte:fragment slot="leftContent">
				<ListSkeletonGrid
					count={SKELETON_CARD_COUNT}
					variant="device-widget"
					sm={100}
					lg={160}
					xl={160}
					gridRowMinContent
					disableGridMaxHeight
				/>
			</svelte:fragment>
			<svelte:fragment slot="rightContent">
				<ListSkeletonGrid
					count={SKELETON_CARD_COUNT}
					variant="control-widget"
					sm={100}
					lg={160}
					xl={160}
					gridRowMinContent
					disableGridMaxHeight
				/>
			</svelte:fragment>
		</DashLayout>
	</div>
{/if}
